export const EPSILON = 0.0001;
export const TWO_PI = Math.PI * 2;
export const HALF_PI = Math.PI * 0.5;
export const MAX_GEOMETRY_DIMENSION = 200.0;
//# sourceMappingURL=constants.js.map